import { isAgentProfile } from "@/features/onboarding/agent-type";
import type { Viewer } from "@/server/auth/types";

export const identities = {
  creator: { label: "个体授权方", english: "CREATOR", title: "授权方控制台", color: "var(--color-cool)" },
  // 有所属代理商的授权方（个人）：页面与权限同授权方，授权可由机构代为确认。
  signed: { label: "签约授权方", english: "SIGNED CREATOR", title: "授权方控制台", color: "var(--color-cool)" },
  brand: { label: "电商厂商", english: "VENDOR · E-COMMERCE", title: "厂商控制台", color: "var(--color-warm)" },
  director: { label: "影视厂商", english: "VENDOR · FILM", title: "厂商控制台", color: "var(--color-accent)" },
  agent: { label: "人像采集点", english: "AGENT", title: "人像采集点控制台", color: "var(--color-verified)" },
  partner: { label: "厂商", english: "BUSINESS", title: "厂商控制台", color: "var(--color-accent)" },
} as const;
export type WorkbenchIdentity = keyof typeof identities;
export function resolveIdentity(role: Viewer["role"], profile?: { agentType?: string | null; agentCity?: string | null; merchantType?: string | null } | null): Exclude<WorkbenchIdentity, "signed"> {
  if (role === "creator") return "creator";
  if (isAgentProfile(profile)) return "agent";
  if (profile?.merchantType === "director") return "director";
  if (profile?.merchantType === "brand") return "brand";
  return "partner";
}
